/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_TitleInputs */

const vi_cdo_title = /** @type {(inputs: Cdo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn giao hợp đồng`)
};

/**

* @param {Cdo_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_title = /** @type {((inputs?: Cdo_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_title(inputs)
});